import React from "react";
import { FaArrowLeft } from "react-icons/fa";

const BackButton = ({ onClick }) => (
  <button
    type="button"
    className="hidden md:flex items-center space-x-[18px]"
    onClick={onClick}
  >
    <FaArrowLeft style={{ width: "32px", height: "24px" }} />
    <h4 className="text-pw-blue text-xl font-semibold">Back</h4>
  </button>
);

export default BackButton;
